$(function () {


    $('.section-hiw__slider').slick({
        //slide: 'div',
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: $('.section-hiw__controls'),
        customPaging: function (slider, i) {
            console.log(slider);
            return $('<button type="button" />').text($(slider.$slides[i]).find('.section-hiw__slide').attr('data-title'));
        }
    });


    var $window = $(window),
        $body = $('body'),
        $header = $('header');

    // Disable animations/transitions until the page has loaded.

    $window.on('load', function () {
        window.setTimeout(function () {
            $body.removeClass('is-loading');
        }, 100);
    });
    /*
        // Scrolly.
        $('.scrolly')
            .scrolly({
                speed: 1000,
                offset: $header.outerHeight()
            });

        // Scrolly.
        $('.navigation-aside__nav .menu-item a,.scrolly-fast')
            .scrolly({
                speed: 1000,
                //offset: $header.outerHeight()
            });*/


    var Shuffle = window.Shuffle;


    let grid = document.querySelector('.inspiration-grid');
    if (grid) {
        let filters = [];
        $('.inspiration-grid__brick').each(function (i, elem) {

            let titles = $(elem).attr('data-alt');
            if (titles && titles.length > 0) {
                let titlesArray = titles.split(',');
                titlesArray.forEach(function (title) {
                    if (title && filters.indexOf(title) < 0) {
                        filters.push(title)
                    }
                });
                $(elem).attr('data-groups', titles)
            } else {
                $(elem).attr('data-groups', '')
            }

        });

        let $filter = $('.inspiration__filter');
        filters.forEach(function (item) {
            $('<a href="#"></a>').attr('data-group', item).text(item).appendTo($filter)
        });

        $filter.on('click', 'a', function (e) {
            e.preventDefault();
            $filter.find('a').removeClass('active');
            if ($(this).attr('data-group') === Shuffle.ALL_ITEMS) {
                myShuffle.filter(Shuffle.ALL_ITEMS)
            } else {
                myShuffle.filter([$(this).attr('data-group')])
            }
            $(this).addClass('active');
        });

        Shuffle.ALL_ITEMS = 'all';
        Shuffle.FILTER_ATTRIBUTE_KEY = 'groups';

        var myShuffle = new Shuffle(grid, {
            itemSelector: '.inspiration-grid__brick',
            sizer: '.my-sizer-element',
            buffer: 0,
            columnThreshold: 1,
            delimeter: ','
        });
    }

    $('.front-masonry__item:not(.front-masonry__item--link) a, .inspiration-grid__brick:not(.inspiration-grid__brick--static) a').click(function (e) {
        e.preventDefault();
        let $item = $(this).closest('.front-masonry__item, .inspiration-grid__brick');
        let $modal = $('#inspirationModal');

        $modal.find('.bs-modal__title').text($item.attr('data-title'));
        $modal.find('.bs-modal__caption').text($item.attr('data-caption'));
        $modal.find('.bs-modal__description').text($item.attr('data-description'));
        $modal.find('.bs-modal__img').attr('src', $item.attr('data-src'));

        $modal.modal('show')
    });
});


//DEMO
$(function () {


});
